import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

import ExpiredStepPaymentLink from './expired-step';
import ProductStep from './product-step';
import StepPayment from './step-payment';
import PaidStepPaymentLink from './paid-step';
import ErrorStepPaymentLink from './error-step';
import { useParams } from 'react-router-dom';
import { getPaymentLinkById } from '../../services/api.service';
import StepPersonnalInfosFormPaymentLink from './step-personnal-infos-form';
import { useTranslation } from 'react-i18next';

export default function PaymentLinkPage() {
    const { t } = useTranslation();
    const { id } = useParams();
    const [paymentLinkData, setPaymentLinkData] = useState(null);
    const [step, setStep] = useState('step1');
    const [isExpired, setIsExpired] = useState(false);
    const [formData, setFormData] = useState({
        customer: {},
        billing: {},
        products: [],
        paymentLinkToken: '',
        type: "payment-link"
    });

    useEffect(() => {
        const fetchData = async () => {
            const data = await getPaymentLinkById(id);
            setPaymentLinkData(data);

            const expired = !data || data?.isExpired || (data?.canBeUsedOnlyOnce && data?.isPaid);
            setIsExpired(expired);

            setFormData(prev => ({
                ...prev,
                products: data?.products || [],
                paymentLinkToken: data?.token || '',   // <-- use data.token here
            }));
        };
        fetchData();
    }, [id]);


    const handleReturnedData = (data) => {
        setFormData((prevData) => ({
            ...prevData,
            ...data,
        }));

        if (data?.step) setStep(data.step);
    };

    if (isExpired) {
        return (
            <ExpiredStepPaymentLink />
        );
    }

    return (
        <div className='m-auto max-w-5xl py-6 md:pt-14 mt-16 md:mt-20'>
            <Helmet>
                <title>{t('pagePaymentLink.page')}</title>
                <meta name="description" content={t('pagePaymentLink.description')} />
            </Helmet>

            <div className="max-w-5xl mx-auto rounded-md p-6">
                {step === 'step1' && (
                    <ProductStep
                        paymentLinkData={paymentLinkData}
                        returnedData={handleReturnedData}
                    />
                )}

                {step === 'step2' && (
                    <StepPersonnalInfosFormPaymentLink
                        returnedData={handleReturnedData}
                        initialFormData={formData}
                    />
                )}

                {step === 'step3' && (
                    <StepPayment
                        formData={formData}
                        returnedData={handleReturnedData}
                    />
                )}

                {step === 'paid' && <PaidStepPaymentLink />}
                {step === 'error' && <ErrorStepPaymentLink />}
            </div>
        </div>
    );
}
